export interface FilterOption {
  label: string;
  value: string;
}

interface FilterChipGroupProps {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterChipGroup({ label, options, value, onChange }: FilterChipGroupProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="text-sm text-foreground-500 whitespace-nowrap">{label}</span>
      <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 flex-wrap">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer ${
              value === opt.value
                ? "bg-primary-500 text-background-50 font-medium"
                : "text-foreground-600 hover:text-primary-600"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}